import React, { memo } from 'react'

import { useUnit } from 'effector-react'

import { useCallback } from 'hooks'

import { $features } from 'app/effector/features'

import Input from 'components/_old/Input/Input.jsx'

import { NomineesProvider } from 'components/organisms/IsaTransferForm'

import { $form, $validation, $providersOptions, $shouldShowSkeletonProviders, setField } from '../../index'

const ProviderInput = memo(() => {
  const [form, validation, providersOptions, shouldShowSkeletonProviders] = useUnit([
    $form,
    $validation,
    $providersOptions,
    $shouldShowSkeletonProviders,
  ])
  const features = useUnit($features)

  const handleChange = useCallback(
    (value: string | number | null) =>
      setField({
        field: 'provider',
        value,
      }),
    [],
  )

  if (!features.get('multiple-sipp-providers-transfer')) {
    return <Input type="hidden" name="provider" value={form.provider ?? ''} />
  }

  return (
    <NomineesProvider
      label="Existing pension providers"
      paperSize={4}
      value={form.provider ?? ''}
      options={providersOptions}
      validation={validation.provider}
      setValue={handleChange}
      isForceValidationEnabled={false}
      skeleton={shouldShowSkeletonProviders}
    />
  )
})
ProviderInput.displayName = 'ProviderInput'

export { ProviderInput }
